import { combineReducers } from 'redux';

import sweepsMerchantLogos from 'core/modules/Sweeps/components/SweepsMerchantLogos/reducers';

export default combineReducers({
  sweepsMerchantLogos,
});
